export const actionTypes = {
    SET_REDIRECT_LOGIN_BOOKMAKER: 'SET_REDIRECT_LOGIN_BOOKMAKER',
    CLEAR_REDIRECT_LOGIN_BOOKMAKER: 'CLEAR_REDIRECT_LOGIN_BOOKMAKER',
};

export const setRedirectLoginBookmaker = feed => ({
    type: actionTypes.SET_REDIRECT_LOGIN_BOOKMAKER,
    feed,
});

export const clearRedirectLoginBookmaker = () => ({
    type: actionTypes.CLEAR_REDIRECT_LOGIN_BOOKMAKER,
});




// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/bookmakersSwitcher.actions.js